import type { SessionSubscription } from "@/lib/auth/sessionTypes";

export const PAST_DUE_GRACE_PERIOD_MS = 2 * 24 * 60 * 60 * 1000; // 2 days

function getManualGraceUntilTime(
  subscription: SessionSubscription,
): number | null {
  const metadata = subscription.metadata;
  if (!metadata || typeof metadata !== "object" || Array.isArray(metadata)) {
    return null;
  }

  const value = (metadata as Record<string, unknown>).manual_grace_until;
  if (typeof value !== "string" || value.length === 0) return null;

  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : null;
}

export function getPastDueGraceEndsAt(
  subscription: SessionSubscription,
): number | null {
  if (subscription.status !== "past_due") return null;

  const manualGraceUntil = getManualGraceUntilTime(subscription);
  if (manualGraceUntil && manualGraceUntil > Date.now()) {
    return manualGraceUntil;
  }

  const periodStart = subscription.current_period_start;
  if (!periodStart) return null;

  const startTime = new Date(periodStart).getTime();
  return Number.isFinite(startTime)
    ? startTime + PAST_DUE_GRACE_PERIOD_MS
    : null;
}

export function isPastDueWithinGrace(
  subscription: SessionSubscription,
): boolean {
  const graceEndsAt = getPastDueGraceEndsAt(subscription);
  return graceEndsAt !== null && Date.now() < graceEndsAt;
}
